<!--
 * @Author: your name
 * @Date: 2021-10-19 18:14:45
 * @LastEditTime: 2021-10-21 14:04:04
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /ark-student-wap/src/pages/wechatBinding/toBind.vue
-->
<!--  -->
<template>
  <div class="tobind">
    <div class="bind-box">
      <img src="@/assets/img/public/bind-wx.png" alt="" />
      <button @click="toBind()">
        去绑定
      </button>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {
    toBind() {
      this.$router.replace({
        path: '/wechatBindingAccount',
        query: { bindingConfirm: true, ...this.$route.query },
      });
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.tobind {
  position: fixed;
  width: 100%;
  height: 100%;
  padding-top: 340px;
  background: #fff;
  .bind-box {
    width: 488px;
    margin: 0 auto;
    > img {
      width: 488px;
      height: 460px;
    }
    > button {
      width: 482px;
      height: 89px;
      margin-top: 58px;
      color: #fff;
      font-weight: 500;
      font-size: 32px;
      line-height: 89px;
      background: #ff6c02;
      border-radius: 12px;
    }
  }
}
</style>
